var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 3.66667V2.66227C1.33333 2.29651 1.63687 2 1.99453 2H14.0055C14.3707 2 14.6667 2.29663 14.6667 2.66227V13.3377C14.6667 13.7035 14.3631 14 14.0055 14H1.99453C1.62937 14 1.33333 13.7034 1.33333 13.3377V12.6667H13.3333V4.86667L8 9.66667L1.33333 3.66667ZM0 6.66667H3.33333V8H0V6.66667ZM0 10H5.33333V11.3333H0V10Z",
    fill: "#0F62FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.f375f41f1514f0eb49b555304fe509fa.svg";
export { ForwardRef as ReactComponent };